module.exports = __webpack_public_path__ + "img/ico-delete.6392b685.svg";